import { post } from '@tencent/pmd-network';

export function getBattleTotal({ battleTotal }) {
  if (!battleTotal) {
    return {
      curRoundName: '',
      nostartBatNums: 0,
      playingBatNums: 0,
      endBatNums: 0,
      boType: 0,
    };
  }
  return {
    curRoundName: battleTotal.cur_round_name || '',
    nostartBatNums: battleTotal.nostart_bat_nums || 0,
    playingBatNums: battleTotal.playing_bat_nums || 0,
    endBatNums: battleTotal.end_bat_nums || 0,
    boType: battleTotal.bo_type || 0,
  };
}

export function getBattleInfoList(childId, schId) {
  return new Promise((resolve, reject) => {
    // https://git.code.oa.com/itrpcprotocol/esport/esport_cgi/blob/master/mobaschedule/mobaschedule.proto
    post({
      reqData: {
        childid: childId, // 子活动id
        gid: 331,
        schid: schId, // 赛程组id
      },
      url: '/pvpesport.sgamenes.nesplayer.nesplayer/GetSchBattleDetails',
    })
      .then((rsp) => {
        resolve(rsp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
// 获取赛中实时数据
export function getSchBattleData(childId, schId) {
  return new Promise((resolve, reject) => {
    // https://git.code.oa.com/itrpcprotocol/esport/esport_cgi/blob/master/mobaschedule/mobaschedule.proto
    post({
      reqData: {
        childid: childId, // 子活动id
        gid: 331,
        schid: schId, // 赛程组id
      },
      url: '/pvpesport.sgamenes.nesplayer.nesplayer/GetSchBattleData',
    })
      .then((rsp) => {
        resolve(rsp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getSimulateBattleInfoList(childId, schId) {
  return post({
    url: '/pvpesport.sgamenes.simulate_match.simulate_match/GetVirtualBattleDetails',
    reqData: {
      child_id: childId,
      gid: 331,
      schedule_id: schId,
    },
  });
}
